import React from "react";
import styles from "./TopicSelector.module.css";

interface Topic {
  id: string;
  label: string;
  icon: string;
}

interface TopicSelectorProps {
  topics: readonly Topic[];
  onTopicSelect: (topicId: string) => void;
  onBack: () => void;
  onSkip: () => void;
}

const TopicSelector: React.FC<TopicSelectorProps> = ({ topics, onTopicSelect, onBack, onSkip }) => {
  return (
    <div className={styles.container} role="region" aria-label="Topic Selection">
      <p className="eta">
        Say hello with a quick note! Pick a topic and share a little about yourself.
      </p>

      <div className={styles.grid} role="list">
        {topics.map((topic) => (
          <button
            key={topic.id}
            onClick={() => onTopicSelect(topic.id)}
            className={`${styles.topicButton} __staple--small`}
            aria-label={`Select ${topic.label} topic`}
            role="listitem">
            <img src={topic.icon} alt="" aria-hidden="true" className={styles.topicIcon} />
            <span>{topic.label}</span>
          </button>
        ))}
      </div>

      <nav className={styles.navigation} aria-label="Topic navigation">
        <button onClick={onBack} className="btn-link" aria-label="Go back to photo">
          ← Back to photo
        </button>
        <button onClick={onSkip} className="btn-link" aria-label="Skip message section">
          Skip message
        </button>
      </nav>
    </div>
  );
};

export default TopicSelector;
